import * as yup from "yup";

export const labelsValidator = yup.object().shape({
  name: yup.string().required("Name is required"),
  color: yup.string().required(),
});
